import { Box } from '@mui/material';
import styled from 'styled-components';

export const ImagesWrapper = styled(Box)`
  display: flex;
  gap: 20px;
`;
